import React from 'react';
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import {
  ENGAGEMENT_PLANS,
  RESALE_PLAN,
  GETTING_STARTED,
} from '../data/engagement';
import SectionHead from './SectionHead';
import PointList from './PointList';
import layout from '../styles/layout.module.css';
import styles from './EngagementSection.module.css';

const EngagementSection: React.FC = () => {
  const { elementRef, isVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section
      id="engagement"
      className={layout.section}
      aria-labelledby="engagement-title"
    >
      <div
        ref={elementRef}
        className={`${layout.wrap} ${layout.sectionInner} slide-up ${isVisible ? 'visible' : ''}`}
      >
        <SectionHead
          eyebrow="HOW WE WORK"
          title="関わり方"
          titleId="engagement-title"
          lead="月額の顧問として長く、あるいはスポットで短く。AWS の契約そのものを eNEW 経由にすることもできます。必要な範囲だけを、一緒に決めます。"
        />

        <div className={styles.plans}>
          {ENGAGEMENT_PLANS.map((plan) => (
            <div key={plan.id} className={styles.plan}>
              <h3 className={styles.planTitle}>{plan.title}</h3>
              <p className={styles.planText}>{plan.description}</p>
              <PointList items={plan.points} />
            </div>
          ))}
        </div>

        <div className={styles.resale}>
          <div className={styles.resaleCopy}>
            <h3 className={styles.planTitle}>{RESALE_PLAN.title}</h3>
            <p className={styles.planText}>{RESALE_PLAN.description}</p>
          </div>
          <PointList items={RESALE_PLAN.points} className={styles.resaleList} />
        </div>

        <div className={styles.start}>
          <p className={styles.startLabel}>はじめ方</p>
          <div className={styles.startBody}>
            <p className={styles.planText}>{GETTING_STARTED}</p>
            <Link to="/contact" className={layout.inlineLink}>
              相談する →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EngagementSection;
